module.exports = __webpack_public_path__ + "r-v3/img/deepHearing.9dc6a769.png";